import { Button, Modal, Collapse } from "antd";
import { ContainerButton } from "../styles";
import { validateToken } from "../../../components/Globais";
const isAdmin = validateToken()?.nda;

const actionButtons = [
  { key: "2", label: isAdmin == 1 ? "Alugar" : "Quero Alugar" },
  { key: "3", label: isAdmin == 1 ? "Trocar" : "Quero Trocar" },
  {
    key: "4",
    label: isAdmin == 1 ? "Alugar ou Trocar" : "Quero Alugar ou Trocar",
  },
  { key: "12", label: isAdmin == 1 ? "Alterar Valor" : "Quero Alterar Valor" },
  {
    key: "5",
    label: isAdmin == 1 ? "Será Utilizado" : "Será Utilizado ou Já Utilizei",
  },
  { key: "6", label: isAdmin == 1 ? "Já Reservei" : "Já Aluguei" },
  // { key: "1", label: isAdmin == 1 ? "Delegar" : "Já Troquei" },
  { key: "1", label: "Delegar" },
  { key: "7", label: "Não Pertube" },
  { key: "8", label: "Excluir Frações" },
];

export default function ModalAcoes({
  isModalOpen,
  handleFechar,
  onClick,
  data,
}: any) {
  const handleButtonClick = (key: string) => {
    const params: any = { key };

    params.situacao = data.situacao;
    params.checkOutPeriodo = data.checkOutPeriodo;
    params.checkInPeriodo = data.checkInPeriodo;
    params.statusAtual = data.statusAtual;
    params.statusAnterior = data.statusAnterior;
    params.periodoUsuario = data.periodoUsuario;
    params.valorSugeridoSistema = data.valorSugeridoSistema;
    params.valorSugeridoSistema1Fracao = data.valorSugeridoSistema1Fracao;
    params.valorSugeridoSistema2Fracao = data.valorSugeridoSistema2Fracao;
    params.periodo = data.periodo;

    onClick(params);
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Ações Disponíveis"
      footer={null}
    >
      <ContainerButton>
        {actionButtons.map((btn) => (
          <Button
            key={btn.key}
            style={{ margin: "5px 0", width: "100%" }}
            onClick={() => handleButtonClick(btn.key)}
          >
            {btn.label}
          </Button>
        ))}
      </ContainerButton>
    </Modal>
  );
}
